import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SubstituteManager.html?raw';
import query from 'dojo/query';

import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";

import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";

import LoadedCalendarWeek from '../SharedTypes/LoadedCalendarWeek';



//  Verfügbare Verträge/Funktionsgruppen
//

interface RefMusicanContractType {
    ID: string;
    Classname: string;
    code: string;
    description: string;
}

interface RefFunctionalGroup {
    ID: string;
    Classname: string;
    description: string;
}

interface RefFunctionalSubGroup {
    ID: string;
    Classname: string;
    code: string;
    description: string;
    ref_functional_group: RefFunctionalGroup;
}

interface ELEngagementFuncSubGroupMusicanContractMd {
    ID: string;
    Classname: string;
    ref_functional_sub_group: RefFunctionalSubGroup;
}

interface SubstituteContract {
    ID: string;
    Classname: string;
    ref_musican_contract_type: RefMusicanContractType;
    compulsor_service_rate: number;
    EL_engagement_func_sub_group_musican_contract_md: ELEngagementFuncSubGroupMusicanContractMd[];
}

// Planung pro Woche
//

interface RefMusicanContractType {
    ID: string;
    Classname: string;
    code: string;
    description: string;
}

interface RefMusicanContractMd {
    ID: string;
    Classname: string;
    gDisp_1: string;
    compulsor_service_rate: number;
    ref_musican_contract_type: RefMusicanContractType;
}

interface RefFunctionalSubGroup {
    ID: string;
    Classname: string;
    code: string;
    description: string;
}

interface RefFunctionalGroup {
    ID: string;
    Classname: string;
    code: string;
    description: string;
}

interface MusicanPlanningTimeUnit {
    ID: string;
    Classname: string;
    ref_musican_contract_md: RefMusicanContractMd;
    ref_functional_sub_group: RefFunctionalSubGroup;
    ref_functional_group: RefFunctionalGroup;
}
class SubstituteManager extends compose(_WidgetBaseSP) {
    templateString: any = template;

    SelectBox_week: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_SubstituteContracts: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_SubstituteContractsOfWeek: MdsLax<InstanceType<typeof SelectBox>>;
    SelectBox_week_Container: HTMLDivElement;
    left_Container: HTMLDivElement;
    center_Container: HTMLDivElement;
    right_Container: HTMLDivElement;
    btnDeletePlanning: MdsLax<InstanceType<typeof Button>>;
    btnAddPlanning: MdsLax<InstanceType<typeof Button>>;

    calendarWeeks: Array<LoadedCalendarWeek> = new Array<LoadedCalendarWeek>();
    substituteContracts: Array<SubstituteContract> = new Array<SubstituteContract>();
    substitutesOfWeek: Array<MusicanPlanningTimeUnit> = new Array<MusicanPlanningTimeUnit>();

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    //
    _onClick_DeleteMusicanPlanning(): void {
        this.StandbyStart();

        //absehden für neues entity
        let url = window.appRoot + "data/DeleteMusicanPlanningOfWeek";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({
                    "week": this.SelectBox_week.getValue(),
                    "ID": this.SelectBox_SubstituteContractsOfWeek.getValue(),
                })
            },
            lang.hitch(this, this.DeleteMusicanPlanning_Response),
            lang.hitch(this, this.DeleteMusicanPlanning_Error)
        );
    }

    DeleteMusicanPlanning_Response(response: Array<MusicanPlanningTimeUnit>): void {
        this.StandbyStop();
        this.substitutesOfWeek = response;
        this._renderRight();
        this.refreshButtonState();
    }

    DeleteMusicanPlanning_Error(error: any): void {
        this.StandbyStop();
        alert(JSON.stringify(error));
        this.refreshButtonState();
    }

    _onClick_AddMusicanPlanning(): void {
        this.StandbyStart();

        // daten aus entity holen
        let contractId = null;
        let functionSubGroupId = null;
        for (let contractEntity of this.substituteContracts) {
            //
            for (let engagement of contractEntity.EL_engagement_func_sub_group_musican_contract_md) {
                if (engagement.ID == this.SelectBox_SubstituteContracts.getValue()) {
                    contractId = contractEntity.ID;
                    functionSubGroupId = engagement.ref_functional_sub_group.ID;
                    break;
                }
            }
        }

        //absehden für neues entity
        let url = window.appRoot + "data/CreateMusicanPlanningOfWeek";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({
                    "week": this.SelectBox_week.getValue(),
                    "contract": contractId,
                    "funcsubgroup": functionSubGroupId
                })
            },
            lang.hitch(this, this.AddMusicanPlanning_Response),
            lang.hitch(this, this.AddMusicanPlanning_Error)
        );
    }

    AddMusicanPlanning_Response(response: Array<MusicanPlanningTimeUnit>): void {
        this.StandbyStop();
        this.substitutesOfWeek = response;
        this._renderRight();
        this.refreshButtonState();
    }

    AddMusicanPlanning_Error(error: any): void {
        this.StandbyStop();
        alert(JSON.stringify(error));
        this.refreshButtonState();
    }

    loadSubstituteContractsOfWeek(): void {
        this.StandbyStart();

        let url = window.appRoot + "data/GetMusicanPlanningOfWeek";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({
                    "week": this.SelectBox_week.getValue()
                })
            },
            lang.hitch(this, this.loadSubstituteContractsOfWeek_Response),
            lang.hitch(this, this.loadSubstituteContractsOfWeek_Error)
        );
    }

    loadSubstituteContractsOfWeek_Response(musicanPlannings: Array<MusicanPlanningTimeUnit>): void {
        this.StandbyStop();
        this.substitutesOfWeek = musicanPlannings;

        this._renderRight();
    }

    loadSubstituteContractsOfWeek_Error(error): void {
        this.StandbyStop();
    }

    loadSubstituteContracts(): void {
        this.StandbyStart();

        let url = window.appRoot + "data/GetSubstituteContracts";
        this.RequestManager.post(
            url,
            {
                "JsonData": JSON.stringify({

                })
            },
            lang.hitch(this, this.loadSubstituteContracts_Response),
            lang.hitch(this, this.loadSubstituteContracts_Error)
        );
    }

    loadSubstituteContracts_Response(contracts: Array<SubstituteContract>): void {
        this.StandbyStop();
        this.substituteContracts = contracts;

        this._renderLeft();
    }

    loadSubstituteContracts_Error(error): void {
        this.StandbyStop();
    }


    _drawWeeks(): void {
        if (this.SelectBox_week != null) {
            this.SelectBox_week.destroy();
            this.SelectBox_week = null;
        }

        this.SelectBox_week = new SelectBox();
        this.SelectBox_week.setLabel("Woche");
        this.SelectBox_week.placeAt(this.SelectBox_week_Container);
        this.SelectBox_week.on("valueChange", lang.hitch(this, this._onChange_Week));

        for (let week of this.calendarWeeks) {
            this.SelectBox_week.addEntry(week.ID, week.label, true);
        }

        this.SelectBox_week.startup();

        this._onChange_Week(); // initialier call für ersten eintrag
    }

    _onChange_Week(): void {
        this.loadSubstituteContractsOfWeek();
    }

    _renderLeft(): void {
        if (this.SelectBox_SubstituteContracts != null) {
            this.SelectBox_SubstituteContracts.destroy();
        }
        this.SelectBox_SubstituteContracts = new SelectBox();
        this.SelectBox_SubstituteContracts.setLabel("Aushilfe wählen");
        this.SelectBox_SubstituteContracts.setMultiselectHeight(8);
        this.SelectBox_SubstituteContracts.placeAt(this.left_Container);

        for (let contractEntity of this.substituteContracts) {
            //
            for (let engagement of contractEntity.EL_engagement_func_sub_group_musican_contract_md) {
                this.SelectBox_SubstituteContracts.addEntry(engagement.ID, engagement.ref_functional_sub_group.description + " (" + contractEntity.compulsor_service_rate+"%)");
            }
        }
        this.SelectBox_SubstituteContracts.on("valueChange", lang.hitch(this, this.onChange_SubstituteContracts));

        this.SelectBox_SubstituteContracts.startup();
    }

    onChange_SubstituteContracts(): void {
        this.refreshButtonState();
    }

    _renderCenter(): void {

    }

    _renderRight(): void {
        if (this.SelectBox_SubstituteContractsOfWeek != null) {
            this.SelectBox_SubstituteContractsOfWeek.destroy();
        }
        this.SelectBox_SubstituteContractsOfWeek = new SelectBox();
        this.SelectBox_SubstituteContractsOfWeek.setMultiselect(true);
        this.SelectBox_SubstituteContractsOfWeek.setMultiselectHeight(8);
        this.SelectBox_SubstituteContractsOfWeek.setLabel("Geplant in Woche");
        this.SelectBox_SubstituteContractsOfWeek.placeAt(this.right_Container);

        for (let musicanPlanning of this.substitutesOfWeek) {
            //
            this.SelectBox_SubstituteContractsOfWeek.addEntry(musicanPlanning.ID, musicanPlanning.ref_functional_sub_group.description + " (" + musicanPlanning.ref_musican_contract_md.compulsor_service_rate + "%)");
        }
        this.SelectBox_SubstituteContractsOfWeek.on("valueChange", lang.hitch(this, this.onChange_SubstituteContractsOfWeek))
        this.SelectBox_SubstituteContractsOfWeek.startup();

        query(".w3-input", this.SelectBox_SubstituteContractsOfWeek.domNode).forEach(function (node) {
            this.UiModder.domClass.remove(node, "w3-input"); // w3-input vom Select entfernen damit die höhe korrekt dargestellt wird
            if (node instanceof HTMLElement){
                node.style.width = "100%"; //weil w3-input wegfaellt ist breite kaputt #28674
            }
        }, this);

    }

    onChange_SubstituteContractsOfWeek(): void {
        this.refreshButtonState();
    }

    refreshButtonState(): void {
        if (this.SelectBox_SubstituteContracts != null &&
            this.SelectBox_SubstituteContracts.getValue() != "" &&
            this.SelectBox_SubstituteContracts.getValue() != null) {
            this.btnAddPlanning.setReadonly(false);
        } else {
            this.btnAddPlanning.setReadonly(true);
        }

        if (this.SelectBox_SubstituteContractsOfWeek != null &&
            this.SelectBox_SubstituteContractsOfWeek.getValue() != "" &&
            this.SelectBox_SubstituteContractsOfWeek.getValue() != null) {
            this.btnDeletePlanning.setReadonly(false);
        } else {
            this.btnDeletePlanning.setReadonly(true);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._drawWeeks();
        this.loadSubstituteContracts();
        this.refreshButtonState();
    }
}

export default mdsWidget(SubstituteManager);
